import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CustomPropsJson, Element } from "./types";
import SectionInput from "./SectionInput";
type DynamicSectionInputProps = {
  element: Element & {
    element: {
      customPropsJson: CustomPropsJson | null;
    };
  };
  dependentElement: Element | null | undefined;
  disabled?: boolean;
  institutionSlug: string | undefined;
  isPreviewOnly?: boolean;
};
const elementValidatorTypeGuard = <T extends string,>(elementValidator: Element["element"]["validators"][number], type: T): elementValidator is Element["element"]["validators"][number] & {
  validator: {
    type: T;
  };
} => {
  return elementValidator.validator.type === type;
};
const DynamicSectionInput = ({
  element,
  dependentElement,
  disabled = false,
  institutionSlug,
  isPreviewOnly
}: DynamicSectionInputProps) => {
  const form = useFormContext();
  const defaultValue = form.getValues()[dependentElement?.id || ""] === undefined ? false : form.getValues()[dependentElement?.id || ""];
  const dependentInput = useWatch({
    name: dependentElement?.id || "",
    exact: true,
    defaultValue
  });
  const clientSideDynamicConditionFulfilled = () => {
    const validator = element?.element.validators.find(validator => validator.validator.type === "CLIENT_SIDE_DYNAMIC");
    if (!validator || !elementValidatorTypeGuard(validator, "CLIENT_SIDE_DYNAMIC")) {
      return true;
    }
    return dependentInput === validator.validator.options?.requiredValue;
  };
  return clientSideDynamicConditionFulfilled() || !dependentElement ? <SectionInput disabled={disabled} key={element.element.id} element={{
    ...element.element,
    id: element.id,
    customPropsJson: element.customPropsJson
  }} institutionSlug={institutionSlug} isPreviewOnly={isPreviewOnly} data-sentry-element="SectionInput" data-sentry-component="DynamicSectionInput" data-sentry-source-file="DynamicSectionInput.tsx" /> : null;
};
export default DynamicSectionInput;